'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$22() {
  this.beU = null;
  this.beS = null;
  this.beT = false;
  this.beQ = null;
  this.beR = false;
  this.beV = false;
  this.beW = false;
  this.beU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$22 as $c_Lpresto_PrestoRouter$$anon$22 };
$p = $c_Lpresto_PrestoRouter$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$22;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$22() {
}
export { $h_Lpresto_PrestoRouter$$anon$22 as $h_Lpresto_PrestoRouter$$anon$22 };
$h_Lpresto_PrestoRouter$$anon$22.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.beU;
});
$p.t = (function() {
  if ((!this.beT)) {
    this.beS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beT = true;
  }
  return this.beS;
});
$p.ad = (function() {
  if ((!this.beR)) {
    this.beQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beR = true;
  }
  return this.beQ;
});
$p.v = (function() {
  if ((!this.beW)) {
    this.beV = false;
    this.beW = true;
  }
  return this.beV;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$22, "presto.PrestoRouter$$anon$22", ({
  NW: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$22 as $d_Lpresto_PrestoRouter$$anon$22 };
//# sourceMappingURL=presto.-Presto-Router$$anon$22.js.map
